import React from "react";
import { BiReset } from "react-icons/bi";
import ToolMenuIconButton from "../../../../common/ToolMenuIconButton";

export interface IProps {
  onClick?: () => void;
}

class ResetFileButton extends React.Component<IProps> {
  private readonly Icon = <BiReset />
  private readonly Tooltip = "Reset config";

  render(): JSX.Element {
    return (
      <div>
        <ToolMenuIconButton
          onClick={this.props.onClick}
          icon={this.Icon}
          tooltip={this.Tooltip}
        />
      </div>
    );
  }
}

/**
 * ファイルリセットボタン
 */
export default ResetFileButton;
